import { PrimaryButton } from '@/app/components/PrimaryButton'
import { ROUTES } from '@/app/lib/constants'
import { ErrorPageWithImage } from '@/app/modules/shared/components/error'
import { useIntl } from 'react-intl'

export default function NotFoundPage() {
  const intl = useIntl()

  return (
    <ErrorPageWithImage
      title={intl.formatMessage({
        id: 'NotFound.title',
        defaultMessage: 'Page Not Found',
      })}
      pageTitle={intl.formatMessage({
        id: 'NotFound.pageTitle',
        defaultMessage: '404 - Page Not Found',
      })}
      description={intl.formatMessage({
        id: 'NotFound.description',
        defaultMessage: "The page you're looking for doesn't exist.",
      })}
      mobileImage="/images/not-found-mobile.png"
      desktopImage="/images/not-found-desktop.png"
      alt={intl.formatMessage({
        id: 'NotFound.alt',
        defaultMessage: 'Page not found illustration',
      })}
    >
      <PrimaryButton href={ROUTES.homepage}>
        {intl.formatMessage({
          id: 'NotFound.backToHome',
          defaultMessage: 'Back to Home',
        })}
      </PrimaryButton>
    </ErrorPageWithImage>
  )
}
